module.exports = __webpack_public_path__ + "img/GISLocation.8be1e35e.png";